import _ from "lodash";

export const productsMixins = {
  data() {
    return {
      untouchedForm: {}
    }
  },
  computed: {
    apiErrors() {
      return _.merge(this.errors, this.estoreErrors) || {};
    }
  },
  methods: {
    discountFormatter(value, event) {
      if (event === null) {
        return value;
      }

      if (this.product_on_sale.discount_type === "%") {
        if (value > 99) {
          return 99;
        }
      } else {
        if (
          Number(value) > this.product_on_sale.regular_price ||
          Number(value) == this.product_on_sale.regular_price
        ) {
          return this.product_on_sale.regular_price - 1 < 0
            ? 0
            : this.product_on_sale.regular_price - 1;
        }
      }
      return value;
    },

    validateState(name, subName = null, index = 0) {
      if (subName && index) {
        if (this.formErrors[name][index][subName]) return false;

        const { $dirty, $error } = this.$v.form[name].$each[index][subName];

        return $dirty ? !$error : null;
      } else {
        if (this.formErrors[name]) return false;

        const { $dirty, $error } = this.$v.form[name];

        return $dirty ? !$error : null;
      }
    },

    isDirtyAndInvalid(formKey, validationKey, subFormKey = null) {
      if (subFormKey)
        return this.$v.form[formKey][subFormKey].$dirty &&
          !this.$v.form[formKey][subFormKey][validationKey];
      else
        return this.$v.form[formKey].$dirty &&
          !this.$v.form[formKey][validationKey];
    },

    formValidatedState(field, subField = null) {
      if (subField && !_.isEmpty(this.apiErrors))
        return this.apiErrors[field][subField];
      else
        return this.apiErrors[field];
    },

    productInfo(field) {
      const productData = this.productDetails;
      const { type } = this.$route.params;

      const info = {
        productName:
          type === "simple"
            ? productData.product_details.name
            : productData.name,
        description:
          type === "simple"
            ? productData.product_details.description
            : productData.description,
        visibility:
          type === "simple" ? productData.visibility : true,
        productImages:
          type === "simple"
            ? productData.product_details.images.map((image, index) => {
              const { deleted_at, ...imageItem } = image;
              _.assign(imageItem, { action: "update", index: index });
              return _.mapKeys(imageItem, (value, key) =>
                key === "image_name" ? "image" : key
              );
            })
            : productData.images.map((image, index) => {
              const { deleted_at, ...imageItem } = image;
              _.assign(imageItem, { action: "update", index: index });
              return _.mapKeys(imageItem, (value, key) =>
                key === "image_name" ? "image" : key
              );
            }),
        categoryId:
          type === "simple"
            ? productData.product_details.category_id
            : productData.category_id,
        add_ons:
          type === "simple"
            ? productData.product_details.add_on_category.map(
              (addOnCategory) => ({
                uuid: addOnCategory.uuid,
                name: addOnCategory.name,
                limit: addOnCategory.limit,
                id: addOnCategory.id,
                items: addOnCategory.add_ons
              })
            )
            : productData.add_on_category.map((addOnCategory) => ({
              uuid: addOnCategory.uuid,
              name: addOnCategory.name,
              limit: addOnCategory.limit,
              id: addOnCategory.id,
              items: addOnCategory.add_ons
            })),
      }
      return info[field];
    },

    saveTransformer(field) {
      const form = this.form;

      const data = {
        add_ons: form.add_ons.map((addon) => {
          addon.items.map((item) => {
            item["price"] = item.is_free ? 0 : item.price;
            item["uuid"] = item.uuid ? item.uuid : null;
            return item;
          });
          return addon;
        })
      };

      return data[field];
    },

    setProductVariablesItemData(data) {
      return {
        action: data.uuid ? "update" : "create",
        variation_code: data.uuid
          ? data.variation_code
          : data.variable.variation_code,
        stock: data.uuid ? data.stock : data.variable.stock,
        currency: data.uuid ? data.currency : data.variable.currency,
        visibility: data.uuid ? data.visibility : data.variable.visibility,
        sku: data.uuid ? data.sku : data.variable.sku,
        regular_price: data.uuid ? data.sale_price : data.variable.regular_price,
        on_sale: data.uuid ? data.on_sale : data.variable.on_sale,
        is_limited_stock: data.uuid ? data.is_limited_stock : data.variable.is_limited_stock,
        uuid: data.uuid ? data.uuid : null
      };
    },

    trimSpaces(evt) {
      evt.target.value = evt.target.value.replace(/ /g, "").trim();
    },

    handleBackButton() {
      if (this.untouchedForm !== JSON.stringify(this.form))
        this.$root.$emit("cancelProductCreation");
      else
        this.$router.go(-1);
    },
  }
}